const ResolutionOptions = Object.freeze({
  COUNTRIES: 'COUNTRIES',
  STATES_PROVINCES: 'STATES_PROVINCES',
  MARKET_AREAS: 'MARKET_AREAS',
  CITIES: 'CITIES'
})
export default ResolutionOptions
export type ResolutionOptionsStrings = typeof ResolutionOptions[keyof typeof ResolutionOptions]
// RESERVE BELOW
